import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import columnDefinitions from '../../shared/columnDefinitions/glJournals';
import { periodColumnDefinition } from '../../shared/columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default function downloadXlsx({
  periodName,
  entities,
  shouldDisplayZero,
  negativeMinus,
  hideDecimals,
  environmentSuffix,
}) {
  return xlsxExport({
    sheetData: [{
      data: entities,
      name: 'BSM GL Journal',
      type: SheetExportTypes.GRID,
      columnDefinitions: [
        periodColumnDefinition,
        ...columnDefinitions,
      ],
      options: {
        shouldDisplayZero,
        negativeMinus,
        hideDecimals,
      },
    }],
    metadata: {
      fileName: `TLS_BSM_GL_Journal_${periodName}${environmentSuffix}`,
    },
  });
}
